import { ValidateQuoteResponse } from "@ssc-booking/api-contracts"

export default ValidateQuoteResponse.build({
    status: "validated",
    isTest: true,
})
